import { useState, useEffect } from "react";
import { callApi } from "../../services/ApiServices";
import {
  ErrorMessage,
  validateImageFile,
  validateRequired,
} from "../../utlis/function";
import { useGlobalStates } from "../../utlis/ClubsContext";

const EditWhyPartnerModal = ({ isOpen, onClose, initialData, onSave }) => {
  const [editData, setEditData] = useState({
    image: null,
    items: [
      { heading: "", description: "" },
      { heading: "", description: "" },
      { heading: "", description: "" },
    ],
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [logoLoading, setLogoLoading] = useState(false);
  const { selectedClub, handleSelectedClubDetail } = useGlobalStates();


  console.log("editData", editData)
    console.log("initial data", initialData)
const defaultItems = Array.from({ length: 3 }, () => ({
  heading: "",
  description: "",
}));
  useEffect(() => {
    if (initialData) {
       const existingItems = initialData.items || [];

    const mergedItems = [
      ...existingItems,
      ...defaultItems.slice(existingItems.length),
    ].slice(0, 3);

    setEditData({
      image: initialData.image || null,
      items: mergedItems,
    });
    }
  }, [initialData]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setErrors((prev) => ({
      ...prev,
      logo: null,
    }));

    const error = validateImageFile(file, 5);
    if (error) {
      setErrors((prev) => ({ ...prev, logo: error }));
      return;
    }

    try {
      setLogoLoading(true);
      const payload = new FormData();
      payload.append("file", file);
      const response = await callApi({
        method: "post",
        url: "file/upload",
        data: payload,
      });

      setEditData((prev) => ({ ...prev, image: response }));
    } catch (error) {
      console.log("error while upload the logo image", error);
    } finally {
      setLogoLoading(false);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...editData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };
    setEditData({
      ...editData,
      items: updatedItems,
    });
    if (index === 0) {
      setErrors((prev) => ({
        ...prev,
        ...(field === "heading" && { heading1: "" }),
        ...(field === "description" && { description1: "" }),
      }));
    }
  };

  const handleSave = async () => {
    const newErrors = {};

    if (!validateRequired(editData.items[0].heading)) {
      newErrors.heading1 = "Heading is required";
    }

    if (!validateRequired(editData.items[0].description)) {
      newErrors.description1 = "Description is required";
    }

    setErrors(newErrors);

    // If there are errors, don't submit
    if (Object.keys(newErrors).length > 0) {
      return;
    }

      const isFormChanged = () => {
      return (
        editData.image?.id !== initialData?.image?.id ||
        editData.items.some(
          (item, index) =>
            item.heading !== initialData?.items[index]?.heading ||
            item.description !== initialData?.items[index]?.description
        )
      );
    };
    if (!isFormChanged()) {
      onClose();
      return;
    }
      setIsSubmitting(true);
    try {
      const fields = {};

      if (editData?.image) fields.partnerImage = editData?.image?.id;

      fields.partnerSolutions = editData?.items?.map((item) => ({
        heading: item?.heading,
        description: item?.description,
      }));
      const response = await callApi({
        method: "put",
        url: `club/update/${selectedClub?.id}`,
        data: { fields },
      });
      if (response.status === 200) {
        handleSelectedClubDetail(selectedClub);
        onClose();
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
    onSave(editData);
    onClose();
  };

  const handleCancel = () => {
    if (initialData) {
      setEditData(initialData);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000bf] p-4">
      <div className="bg-white rounded-2xl w-full max-w-[939px] mx-auto max-h-[90vh] flex flex-col shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {/* Modal Header - Fixed */}
        <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 border-b border-gray-100">
          <h3 className="text-xl sm:text-2xl font-semibold text-black mb-1">
            Why Partner Section
          </h3>
          <p className="text-sm text-textcolor">
            Upload high-quality images to showcase your venue and ad spaces
          </p>
        </div>

        {/* Modal Content - Scrollable */}
        <div className="flex-1 overflow-y-auto px-6 sm:px-8 py-6">
          <div className="space-y-5">
            {/* Upload Logo */}
            <div className="flex items-center gap-3">
              <input
                type="file"
                id="why-partner-logo"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleImageChange}
                className="hidden"
              />
              <label
                htmlFor="why-partner-logo"
                className="w-14 h-14 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center cursor-pointer hover:border-primary transition-colors flex-shrink-0"
              >
                {editData.image ? (
                  <img
                    src={editData?.image?.fileUrl}
                    alt="Logo preview"
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-gray-400"
                  >
                    <path
                      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
                {logoLoading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  </div>
                )}
              </label>
              <div>
                <p className="text-sm font-medium text-black">Upload logo</p>
                <p className="text-xs text-textcolor">Format png, jpg</p>
              </div>
              <ErrorMessage message={errors.logo} />
            </div>

            {/* Heading and Description Fields */}
            {editData?.items?.map((item, index) => (
              <div key={index} className="space-y-3">
                {/* Heading */}
                <div>
                  <label className="block text-sm font-medium text-textcolor mb-1.5">
                    Heading-{index + 1}
                  </label>
                  <input
                    type="text"
                    value={item.heading}
                    onChange={(e) =>
                      handleInputChange(index, "heading", e.target.value)
                    }
                    placeholder="Enter heading"
                    className="w-full px-4 py-2.5 border border-[#C5C5C5] rounded-xl text-sm text-black focus:outline-none focus:ring-1 focus:ring-primary"
                  />
                  {index === 0 && <ErrorMessage message={errors.heading1} />}
                </div>

                {/* Description */}
                <div>
                  <label className="block text-sm font-medium text-textcolor mb-1.5">
                    Description
                  </label>
                  <textarea
                    rows="3"
                    value={item.description}
                    onChange={(e) =>
                      handleInputChange(index, "description", e.target.value)
                    }
                    placeholder="Enter description"
                    className="w-full px-4 py-2.5 border border-[#C5C5C5] rounded-xl text-sm text-black focus:outline-none focus:ring-1 focus:ring-primary resize-none"
                  />
                  {index === 0 && (
                    <ErrorMessage message={errors.description1} />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal Footer - Fixed */}
        <div className="px-6 sm:px-8 py-5 border-t border-gray-100">
          <div className="flex items-center gap-3 justify-center">
            <button
              onClick={handleCancel}
              className="max-w-[255px] cursor-pointer flex-1 px-6 py-3 text-base font-medium text-primary bg-white border border-primary rounded-full hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              disabled={isSubmitting}
              className={`max-w-[255px] flex-1 px-6 py-3 text-base font-medium rounded-full transition-colors flex items-center justify-center ${isSubmitting ? "bg-primary/80 cursor-not-allowed" : "bg-primary hover:bg-[#164349] cursor-pointer"} text-white`}            >
              {isSubmitting ? (
                <>
                  <svg
                    className="animate-spin mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditWhyPartnerModal;
